import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  createRegulatoryDetail,
  createRegulatoryDetailsReplyData,
  MockRegulatoryDetailsReplyData,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  defaultBoardingPassResult,
  incompleteIdentityRegulatoryDetails,
  incompletePersonalRegulatoryDetails,
  journeys,
  missingRegulatoryJourneyElementCommon,
  noItemToPayError,
  seatmap,
} from '../../mock/data';
import {
  idCard,
  personalDetails,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

const completedRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    ...incompleteIdentityRegulatoryDetails,
    statusCleared: true,
    storedDetails: [
      createRegulatoryDetail({
        template: {
          personalDetails: personalDetails
        }
      }),
      createRegulatoryDetail({
        template: {
          document: idCard
        }
      })
    ],
    missingDetails: []
  }
});

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 * Missing Regulatory Details
 */
export const ow1Journey1AdtMissingRegulatory: MockMap = {
  addRegulatoryDetails: [
    createMockData(incompleteIdentityRegulatoryDetails),
    createMockData(completedRegulatoryDetails)
  ],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [createMockData(incompletePersonalRegulatoryDetails)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse([{
      ...journeys[0],
      journeyElements: [missingRegulatoryJourneyElementCommon]
    }], 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
